import React, { useEffect, useState } from 'react';
import { Form, Input, Col, Row, Select, Modal } from 'antd';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/dateFormat';

const UpdateUserModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [selectedValues, setSelectedValues] = useState([]);
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    if (props.selectedUser) {
      setSelectedValues(props.selectedUser.DEVICE_LOC);
      setUserType(props.selectedUser.TYPE);
      form.setFieldsValue(props.selectedUser);
    }
  }, [props.selectedUser]);

  const onFinish = (values) => {
    values.rooms = _.join(selectedValues, ',');
    props.action(values);
    form.resetFields();
    props.close();
  };

  const handleUserTypeChange = (value) => {
    setUserType(value);
  };

  return (
    <Modal
      title={t("UserPage.updateUser")}
      open={true}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedUser}
        layout="vertical"
      >
        <p>
          ID:{" "}
          <span style={{ fontWeight: "bold" }}>
            {props.selectedUser ? props.selectedUser.ID : ""}
          </span>
        </p>
        <p>
          {t("UserPage.table.created")}:{" "}
          <span style={{ fontWeight: "bold" }}>
            {props.selectedUser
              ? formatDateTime(props.selectedUser.CREATED)
              : ""}
          </span>
        </p>
        <p>
          {t("UserPage.table.lastModified")}:{" "}
          <span style={{ fontWeight: "bold" }}>
            {props.selectedUser
              ? formatDateTime(props.selectedUser.LAST_UPDATE)
              : ""}
          </span>
        </p>

        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.username")}
              name="LOGIN_NAME"
              rules={[{ required: true, message: t("UserPage.validation.username") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.fullname")}
              name="FULL_NAME"
              rules={[{ required: true, message: t("UserPage.validation.fullname") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.email")}
              name="EMAIL"
              rules={[{ required: true, message: t("UserPage.validation.email") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.phone")}
              name="PHONE"
              rules={[{ required: true, message: t("UserPage.validation.phone") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("UserPage.table.type")}
              name="TYPE"
              rules={[{ required: true, message: t("UserPage.validation.type") }]}
            >
              <Select placeholder={t("Select")} onChange={handleUserTypeChange}>
                <Select.Option value={1}>{t("Admin")}</Select.Option>
                <Select.Option value={0}>{t("User")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {userType === 0 && (
            <Col span={24}>
              <Form.Item
                label={t("UserPage.table.assignRoom")}
                rules={[{ message: t("UserPage.validation.assignRoom") }]}
              >
                <Select
                  mode="multiple"
                  placeholder={t("rooms.selectRoom")}
                  value={selectedValues}
                  onChange={setSelectedValues}
                  options={props.suggestions}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateUserModal;
